export default {
  'component.globalHeader.theme.switchToLight': 'light',
  'component.globalHeader.theme.switchToDark': 'dark',
};
